import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Link from "@discovery/sonic-api-ng/lib/api/cms/links";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { _ShowDetails, _VideoDetails } from "../optics";
const oneToOneRelationships = { cmpContextLink: Link.Resource.target };
const oneToOneRelationshipsforAd = { fallbackAd: Link.Resource.target };
const _VideoRails = Fold.compose(Optics._CollectionItemGetter, Res._Rel("video"), _VideoDetails);
const _ShowRails = Fold.compose(Optics._CollectionItemGetter, Res._Rel("show"), _ShowDetails);
export const _RailData = Fold.compose(Optics._Col2Items, Fold.alt(_VideoRails, _ShowRails));
export const _SuperStarsList = Fold.compose(Optics._Col2Items, Optics._ColItem2TaxonomyNode, Fold.liftM((attributes, image, route) => ({
    route: route,
    name: M.fromMaybe(attributes.name, ""),
    image: image,
    id: "",
    packages: "",
    videoType: M.of(""),
    packagesM: M.of([]),
}), Optics._TxNode2Attributes, Fold.compose(Optics._TxNode2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes")), Fold.compose(Optics._TxNode2Routes, Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"))));
export const BannerAdPlaceholder = Fold.compose(Optics._CollectionGetter, Fold.mapF(Res.addNewRelationships(oneToOneRelationshipsforAd)), Res._Rel("fallbackAd"), Fold.liftM((image, url) => ({ image, url }), Fold.compose(Res._Rel("images"), Optics._ImagesOfKind("thumbnail"), Res._Response(), Lens.prop("attributes")), Fold.compose(Optics._Link2LinkedContentRoutes, Optics._Route2Attributes, Lens.prop("url"))));
const bannerCustomAttrValidator = optional(record({
    adUnitPath: string,
}));
export const BannerIdM = Fold.compose(Fold.pre(Optics._GetCustomAttributesForComponent(bannerCustomAttrValidator)), M._Just(), M._Just(), Lens.prop("adUnitPath"));
//TODO: Move to common
const _Taxonomy2Attributes = Fold.compose(Optics._TxNode2Data, Lens.path("attributes", "name"), M._Just());
export const _MastHeadCarousel = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((attributes, image, route) => ({
    route: route,
    name: M.fromMaybe(attributes.title, ""),
    image: image,
    id: "",
    packages: "",
    videoType: M.of(""),
    packagesM: M.of([""]),
}), Optics._Col2Attributes, Fold.compose(Optics._Col2Items, Optics._ColItem2Image, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes")), Fold.compose(Fold.mapF(Res.addNewRelationships(oneToOneRelationships)), Res._Rel("cmpContextLink"), Res._Rel("linkedContentRoutes"), Res._ForEach(), Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"))));
export const _CarouselSquareLogo = Fold.compose(Optics._Col2Items, Optics._ColItem2TaxonomyNode, Fold.liftM((name, image, route, mobileImg) => ({
    route: route.url,
    name,
    image,
    id: "",
    packages: "",
    packagesM: M.of([""]),
    videoType: M.of(""),
    mobileImg,
}), _Taxonomy2Attributes, Fold.compose(Optics._TxNode2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "logo"), Res._Response(), Lens.prop("attributes")), Fold.compose(Optics._TxNode2Routes, Traversal._filteredOn(Res._Response(), (route) => route.attributes.canonical === true), Res._Response(), Lens.prop("attributes")), Fold.compose(Optics._TxNode2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes"))));
export const _VideoRailsForPoster = Fold.compose(Optics._CollectionItemGetter, Res._Rel("video"), _VideoDetails);
export const _ShowRailsForPoster = Fold.compose(Optics._CollectionItemGetter, Res._Rel("show"), _ShowDetails);
export const _PosterRailData = Fold.compose(Optics._Col2Items, Fold.alt(_VideoRailsForPoster, _ShowRailsForPoster));

